// Shared scripted data for the animated homepage. All illustrative — no real customer data.

export const DONKEY_OBSERVATIONS = [
  "\u201cLet's check the demand before you quit the day job.\u201d",
  "\u201cYour mate saying it's brilliant isn't market research.\u201d",
  "\u201cInteresting idea. Now let's see if anybody will pay for it.\u201d",
  "\u201cYou have the skills. The numbers are another matter.\u201d",
  "\u201cLet's find the holes before your bank account does.\u201d",
  "\u201cI don't care how excited you are. Show me the evidence.\u201d",
];

// Ideas the engine cycles through automatically. Each has a relatable founder persona.
export const ENGINE_IDEAS = [
  {
    persona: "Sam, ex-accountant, 42",
    title: "Mobile bookkeeping for tradespeople",
    chips: ["10 yrs finance", "\u00a3500 budget", "Evenings free", "Xero pro", "Manchester"],
    research: [
      { label: "Demand signals", value: 72 },
      { label: "Competition gap", value: 58 },
      { label: "Reachable customers", value: 64 },
    ],
    sources: 18,
    checks: [
      { t: "Tradespeople actually pay for this", ok: true },
      { t: "You can reach them without paid ads", ok: true },
      { t: "\u201cEveryone needs a bookkeeper\u201d \u2014 too vague", ok: false },
    ],
    verdict: { label: "WORTH TESTING", score: 74, note: "Real demand and you can reach them cheaply. Test it." },
  },
  {
    persona: "Leah, burnt-out coach, 35",
    title: "Notion templates for coaches",
    chips: ["Notion power-user", "\u00a350 budget", "5 hrs / week", "Ex-coach", "Remote"],
    research: [
      { label: "Demand signals", value: 61 },
      { label: "Competition gap", value: 34 },
      { label: "Reachable customers", value: 55 },
    ],
    sources: 15,
    checks: [
      { t: "Coaches buy productivity tools", ok: true },
      { t: "The market is already crowded", ok: false },
      { t: "You have a distribution channel", ok: false },
    ],
    verdict: { label: "PROMISING, BUT UNPROVEN", score: 52, note: "Crowded shelf. Prove you can be found before building." },
  },
  {
    persona: "Dan, weekend grafter, 28",
    title: "Weekend dog-walking round",
    chips: ["Loves dogs", "\u00a3100 budget", "Weekends", "Local", "No experience"],
    research: [
      { label: "Demand signals", value: 68 },
      { label: "Competition gap", value: 47 },
      { label: "Reachable customers", value: 71 },
    ],
    sources: 12,
    checks: [
      { t: "Local owners pay for reliability", ok: true },
      { t: "You can start with two clients", ok: true },
      { t: "Hard to grow past your own hours", ok: false },
    ],
    verdict: { label: "WORTH TESTING", score: 66, note: "Easy to test this weekend. Watch the ceiling on your time." },
  },
  {
    persona: "Priya, parent back to work, 39",
    title: "Meal-prep boxes for busy families",
    chips: ["Great cook", "\u00a3300 budget", "School hours", "Home kitchen", "Local"],
    research: [
      { label: "Demand signals", value: 64 },
      { label: "Competition gap", value: 41 },
      { label: "Reachable customers", value: 60 },
    ],
    sources: 16,
    checks: [
      { t: "Busy parents pay for convenience", ok: true },
      { t: "You can start from your own kitchen", ok: true },
      { t: "Food rules and margins are tight", ok: false },
    ],
    verdict: { label: "PROMISING, BUT UNPROVEN", score: 55, note: "Demand is there \u2014 prove the margins before you scale." },
  },
];

export function buildScriptedIdea(text) {
  const set = [
    { label: "WORTH TESTING", score: 71, note: "Plausible demand and a cheap first test. Worth a weekend." },
    { label: "PROMISING, BUT UNPROVEN", score: 57, note: "Interesting \u2014 but prove the demand before you spend." },
    { label: "NEEDS RETHINKING", score: 39, note: "The idea's fine; the way in is weak. Let's sharpen it." },
  ];
  const v = set[Math.abs(text.length) % set.length];
  return {
    title: text.length > 58 ? text.slice(0, 58) + "\u2026" : text,
    custom: true,
    persona: "Your idea",
    chips: ["Your idea", "Your budget", "Your time", "Your skills"],
    research: [
      { label: "Demand signals", value: 63 },
      { label: "Competition gap", value: 49 },
      { label: "Reachable customers", value: 57 },
    ],
    sources: 14,
    checks: [
      { t: "There's a real customer who pays", ok: true },
      { t: "You can reach them cheaply", ok: true },
      { t: "\u201cEveryone will want this\u201d", ok: false },
    ],
    verdict: v,
  };
}

export const ENGINE_PHASES = [
  { key: "understand", label: "Understanding you" },
  { key: "research", label: "Researching demand" },
  { key: "challenge", label: "Challenging assumptions" },
  { key: "verdict", label: "Reaching a verdict" },
];

// Opportunity tournament contenders (illustrative).
export const TOURNAMENT = [
  { name: "Fractional CFO for startups", score: 81, note: "Strong fit, real budgets, reachable." },
  { name: "Budgeting course for freelancers", score: 58, note: "Crowded and hard to be found." },
  { name: "Personal finance newsletter", score: 44, note: "Slow to monetise, weak route in." },
];

// Verdict dimensions (illustrative).
export const VERDICT_DIMENSIONS = [
  { label: "Personal fit", value: 82 },
  { label: "Market demand", value: 74 },
  { label: "Route to customer", value: 69 },
  { label: "Cost to test", value: 88 },
];

export const EVIDENCE_SOURCES = [
  "Search demand",
  "Competitor pricing",
  "Community chatter",
  "Your real skills",
];

export const EVIDENCE_CONCLUSIONS = [
  "Demand is real in 3 tight niches.",
  "Two competitors, both overpriced.",
  "You can reach buyers for under \u00a350.",
  "Best first test: 5 discovery calls.",
];
